import { Box, SxProps, Theme, Typography } from '@mui/material';

import { DocWithMagnifyingGlassIllustration } from '../../../illustrations';

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 0',
  },
  containerSearch: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    padding: '32px 24px',
    minHeight: '200px',
  },
  illustration: {
    width: '120px',
    height: '120px',
  },
  illustrationSearch: {
    width: '140px',
    height: '140px',
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    color: (theme: Theme) => theme.palette.text.primary,
    textAlign: 'center',
  },
  textSearch: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    color: '#46484D',
    textAlign: 'center',
    maxWidth: '280px',
  },
};

interface FilterEmptyStateProps {
  text: string;
  variant?: 'default' | 'search';
}

export function FilterEmptyState({ text, variant = 'default' }: FilterEmptyStateProps) {
  const isSearchVariant = variant === 'search';

  return (
    <Box sx={isSearchVariant ? customStyles.containerSearch : customStyles.container}>
      <DocWithMagnifyingGlassIllustration
        sx={isSearchVariant ? customStyles.illustrationSearch : customStyles.illustration}
      />
      <Typography sx={isSearchVariant ? customStyles.textSearch : customStyles.text}>{text}</Typography>
    </Box>
  );
}
